export default __webpack_public_path__ + "static/BanImg6-7ceb4508b46ffb59d0ef77fb63cff79a.webp";